import axiosClient from '../axiosClient';

const deviceService = {
  async getDevices() {
    try {
      const response = await axiosClient.get('/device');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_fetch_data");
    }
  },

  async downloadSettings(deviceId) {
    return axiosClient.get(`/device/download-setting/${deviceId}`, {
      responseType: 'blob',
    });
  },

  async addDevice(device) {
    try {
      const response = await axiosClient.post('/device', device);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_fetch_data");
    }
  },

  async deleteDevice(deviceId) {
    try {
      const response = await axiosClient.delete(`/device/${deviceId}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_delete_device");
    }
  },

  async updateDevice(deviceId, device) {
    try {
      const response = await axiosClient.put(`/device/${deviceId}`, device);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || "errors.failed_to_update_device");
    }
  }
};

export default deviceService;
